module.exports = __webpack_public_path__ + "img/categories-and-zones.beb7b80c.svg";